var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useLazyGetExpertOpinionQuery } from '../../../../../../../application/features/chat/chat-api';
import useTranslate from '../../../../../../../localization/helpers';
import RichText from '../../../../../../components/RichText';
var ExpertOpinionDrawer = function (_a) {
    var chat = _a.chat, open = _a.open, onClose = _a.onClose;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var _b = __read(useLazyGetExpertOpinionQuery(), 2), getExpertOpinion = _b[0], _c = _b[1].data, expertOpinion = _c === void 0 ? [] : _c;
    useEffect(function () {
        if (chat) {
            var request = {
                conversationId: chat.conversation_id,
                userId: chat.user_id,
                messageId: chat.message_id
            };
            getExpertOpinion(request);
        }
    }, [chat, getExpertOpinion]);
    return (_jsx(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '375px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', xs: '100%' }
                }
            }
        }, variant: 'temporary', anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', open: open, onClose: onClose, children: _jsxs(Box, { sx: {
                display: 'flex',
                width: '100%',
                gap: '8px',
                flexDirection: 'column',
                borderRadius: '16px',
                padding: '16px 20px 16px 20px'
            }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', children: [_jsx(Typography, { variant: 'h6', children: translate('chat.expertOpinion') }), _jsx(IconButton, { size: 'small', onClick: onClose, children: _jsx(CloseIcon, {}) })] }), expertOpinion.map(function (eo) { return (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '12px', p: 2, borderRadius: '12px', bgcolor: '#FFFFFF', boxShadow: theme.customShadows.z24, children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', children: _jsxs(Box, { marginTop: 1, display: 'flex', width: '100%', gap: 1, children: [_jsx(Box, { display: 'flex', justifyContent: 'center', width: '20%', children: _jsx(Avatar, { sx: { width: 48, height: 48 }, children: eo.fullName.charAt(0).toUpperCase() }) }), _jsxs(Box, { width: '80%', children: [_jsx(Box, { width: '100%', children: _jsx(Typography, { variant: 'body1', color: theme.palette.text.primary, children: eo.fullName }) }), _jsx(Box, { width: '100%', children: _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, children: "Senior Tech." }) })] })] }) }), _jsx(RichText, { content: eo.correctedResponse })] }, eo.userId)); })] }) }));
};
export default ExpertOpinionDrawer;
